import React from 'react';
type BookCoverProps = {
  kicker: string;
  title: string;
  number?: string;
  accent?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/** Code-drawn cover in the product look: paper page, accent band, spotlight + soundwave. */
export function BookCover({
  kicker,
  title,
  number,
  accent = 'bg-amber',
  size = 'md',
  className = ''
}: BookCoverProps) {
  const sm = size === 'sm';
  const bars = [5, 11, 17, 9, 21, 13, 7, 18, 10, 6, 14];
  return <div className={`relative aspect-[3/4] overflow-hidden rounded-[10px] bg-cloud shadow-book ${className}`} data-id="element-42" data-mp="2o7hpqe3bfix4">
      <span className={`absolute inset-x-0 top-0 h-[22%] ${accent}`} aria-hidden="true" data-id="element-43" data-mp="2efv6bugtqdja" />
      <svg viewBox="0 0 120 60" className="absolute bottom-[8%] left-[10%] w-[80%]" aria-hidden="true" data-id="element-44" data-mp="2edip5jiw477a">
        <path d="M86 0 L100 0 L114 46 L72 46 Z" fill="#F4B23E" opacity="0.35" data-id="element-45" data-mp="24ho3sgna7y0t" />
        <ellipse cx="93" cy="47" rx="20" ry="3" fill="#F4B23E" opacity="0.6" data-id="element-46" data-mp="24js4yqtsqixe" />
        <circle cx="93" cy="24" r="4" fill="#15213A" data-id="element-47" data-mp="20gm2lu9t1bw7" />
        <path d="M87 31 Q93 28 99 31 L97 46 L89 46 Z" fill="#15213A" data-id="element-48" data-mp="19b14yyw0o10e" />
        {bars.map((h, i) => <rect key={i} x={2 + i * 6} y={40 - h / 2} width="3" height={h} rx="1.5" fill={i % 4 === 1 ? '#E8503A' : '#1F8A8C'} data-id="element-49" data-mp="1e1zo068e3d7c" data-mpi={i} />)}
      </svg>
      <div className="relative flex h-full flex-col px-[11%] pt-[30%]" data-id="element-50" data-mp="zeem2fn93k10">
        <p className={`font-display font-bold uppercase tracking-[0.18em] text-slate ${sm ? 'text-[7px]' : 'text-[9px]'}`} data-id="element-51" data-mp="14cpuclxwdmh4">
          {kicker}
        </p>
        {number && <p className={`mt-1 font-display font-extrabold leading-none text-cloud-dark ${sm ? 'text-3xl' : 'text-5xl'}`} data-id="element-52" data-mp="1x0vg9c0othij">{number}</p>}
        <p className={`mt-2 font-display font-extrabold leading-[1.02] tracking-tight text-ink ${sm ? 'text-[13px]' : 'text-[19px]'}`} data-id="element-53" data-mp="1j014qkicf0fn">
          {title}
        </p>
        <p className={`mt-2 font-semibold uppercase tracking-widest text-slate-soft ${sm ? 'text-[5.5px]' : 'text-[7px]'}`} data-id="element-54" data-mp="7l5sf5765b29">
          52 Weeks of Speaking
        </p>
      </div>
    </div>;
}